import { useLayoutEffect, useRef, useState } from 'react';
import { MAP } from '../../content/map';
import { STATES } from '../../content/states';
import { useS } from '../../store/game';
import { stateMood } from '../../engine/govern';
import { moodT } from '../../engine/view';
import { PC } from '../../engine/rules';

export const moodColor = (v: number) => `color-mix(in oklab, var(--good) ${Math.round(moodT(v) * 100)}%, var(--bad))`;

const OFF: Record<string, [number, number]> = { bb: [25, 30], be: [0, 2], hb: [0, -4], ni: [-20, 15] };

export function GermanyMap({ fill, onPick, selected, suffix }: { fill?: (id: string) => string; onPick: (id: string) => void; selected?: string | null; suffix?: (id: string) => string }) {
  const S = useS();
  const ref = useRef<SVGSVGElement>(null);
  const [labels, setLabels] = useState<{ id: string; x: number; y: number }[]>([]);
  const mode = S.mapMode || 'mood';
  const f = fill || ((id: string) => mode === 'mood' ? moodColor(stateMood(id)) : PC(S.gov[id]));
  useLayoutEffect(() => {
    const svg = ref.current; if (!svg) return;
    const out: { id: string; x: number; y: number }[] = [];
    svg.querySelectorAll<SVGPathElement>('path[data-id]').forEach((p) => {
      try { const b = p.getBBox(); const id = p.dataset.id!; const o = OFF[id] || [0, 0]; out.push({ id, x: b.x + b.width / 2 + o[0], y: b.y + b.height / 2 + o[1] + 5 }); } catch { /* jsdom */ }
    });
    setLabels(out);
  }, []);
  return (
    <svg ref={ref} className="map" viewBox={MAP.vb} role="img" aria-label="Karte der Bundesländer">
      {MAP.l.map((x: any) => <path key={x.id} d={x.d} data-id={x.id} style={{ fill: f(x.id) }} className={selected === x.id ? 'sel' : ''} onClick={() => onPick(x.id)}><title>{STATES[x.id].n}</title></path>)}
      <g className="maplabels">{labels.map((l) => <text key={l.id} x={l.x.toFixed(0)} y={l.y.toFixed(0)}>{l.id.toUpperCase()}{suffix ? suffix(l.id) : ''}</text>)}</g>
    </svg>
  );
}
